import { useReducer } from "react";
import api from "../../../../../api/quiz";

const intialState = {
  templates: []
};

function reducer(state, action) {
  switch (action.type) {
    case "TEMPLATE_LIST":
      return {
        ...state,
        templates: action.templates
      };
    default:
      return {
        ...state,
        ...action.payload
      };
  }
}

export default function useQuestionForm() {
  const [dataSources, dispatch] = useReducer(reducer, intialState);

  function getTemplateList() {
    api.getQuestionTemplateDict().then(({ data }) => {
      dispatch({ type: "TEMPLATE_LIST", templates: data.data });
    });
  }

  return {
    dataSources,
    getTemplateList
  };
}
